// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2XeLY","head":"Table_head__14X0h","col":"Table_col__2azKc"};